<template>
  <div>
    <router-view @statusChanged="getData"></router-view>
    <index-card :loading="loading">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <div class="d-flex justify-center align-center" v-if="canEditClientPortfolio">
            <v-btn color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" @click="$router.push({name:'CreateClientPortfolios'})" center>
              <v-icon small left>mdi-plus</v-icon>Criar Carteira de Clientes
            </v-btn>
          </div>
        </div>
        <div class="d-flex align-center headline white--text">
          <span>Carteira de Clientes</span>
          <v-btn text icon color="white" class="ml-2" aria-label="Atualizar lista" @click="getData()">
            <v-icon class="white--text">mdi-refresh</v-icon>
          </v-btn>
        </div>
      </template>
      <template slot="subheader">
        <div class="index-client-portfolios-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :extra-filters-count="1"
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          >
            <template v-slot:extra-filters>
              <v-col cols="12" md="6">
                <v-select
                  v-model="status_filter"
                  :items="status"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-list-status"
                  label="Status"
                />
              </v-col>
            </template>
          </filter-data>
        </div>
      </template>
      <template slot="subheader_append" v-if="canEditClientPortfolio">
        <v-btn small color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" @click="$router.push({name:'TransferClientsToBetweenClientPortfolios'})" center>
          <v-icon small left>mdi-swap-horizontal</v-icon>Transferir clientes entre carteiras
        </v-btn>
      </template>
      <template slot="data_table">
        <v-data-table 
          :headers="headers_filter" 
          :items="client_portfolios"
          :search="search"
          :loading="loading"
          class="elevation-4" 
          mobile-breakpoint="1"
        >
          <template v-slot:item.attributes.kind="{item}">
            {{ text_map[item.attributes.kind].text }}
          </template>
          <template v-slot:item.attributes.status="{item}">
            <v-chip small :color="text_map[item.attributes.status].color">
              {{ text_map[item.attributes.status].text}}
            </v-chip>
          </template>
          <template v-slot:item.attributes.client_ids="{item}">
            <div class="d-flex align-center justify-center">
              {{ item.attributes.client_ids?.length || 0 }}
              <v-tooltip bottom>
                <template v-slot:activator="{on, attrs}">
                  <v-btn v-bind="attrs" v-on="on" class="ml-1" small icon
                    @click="$router.push({name: 'ShowPortfolioClientsAndEmployees', params:{ id: item.id, kind: 'clients', portfolio_name: item.attributes.name}})">
                    <v-icon small>mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver Clientes da carteira</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.attributes.employee_ids="{item}">
            <div class="d-flex align-center justify-center">
              {{ item.attributes.employee_ids?.length || 0 }}
              <v-tooltip bottom>
                <template v-slot:activator="{on, attrs}">
                  <v-btn v-bind="attrs" v-on="on" class="ml-1" small icon
                  @click="$router.push({name: 'ShowPortfolioClientsAndEmployees', params:{ id: item.id, kind: 'employees'}})">
                    <v-icon small>mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver Funcionários da carteira</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.actions="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" icon @click="$router.push({name: 'ShowClientPortifolio', params: {id: item.id}})">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar Carteira de Clientes</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>
    </index-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/api/index';

export default {
  name:"IndexClientPortfolios",
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    SelectDepot: () => import("@/_backoffice/_registrations/components/shared/SelectDepot.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      search: '',
      status_filter: ['active'],
      loading: false,
      client_portfolios: [],
      status:[
        {text:"Todos", value: ['active', 'disabled']},
        {text:"Ativos", value: ['active']},
        {text:"Desativados", value: ['disabled']},
      ],
      local_filter:{
        status: ['active'],
      },
      text_map:{
        "manual": {text:"Manual"},
        "automatic": {text:"Automático"},
        "activity": {text:"Atividade"},
        "active": {text:"Ativo", color:"success"},
        "disabled": {text:"Desativada", color:"error"},
      },
    }
  },
  computed: {
    headers_filter(){
      let headers = [
        { text: 'Nome', value: 'attributes.name', align: 'center' },
        { text: 'Tipo', value: 'attributes.kind', align: 'center' },
        { text: 'Qtd. Clientes', value: 'attributes.client_ids', align: 'center' },
        { text: 'Qtd. Funcionários', value: 'attributes.employee_ids', align: 'center' },
        { text: 'Status', value: 'attributes.status', align: 'center' },
      ]
      if(this.canEditClientPortfolio){
        headers.push({ text: 'Ações', value: 'actions', align: 'center' })
        return headers
      }else{
        return headers
      }
    },
    canEditClientPortfolio(){
      return this.isDirector() || this.isSalesExecutive()
    },
    ...mapState({
      activeModalityId: state => state.App.activeModalityId,
    }),
  },
  methods: {
    getData(){
      this.getClientPortfolios()
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
      this.local_filter = { ...this.local_filter, status: this.status_filter }
      this.getData()
    },
    showClientPortfolio(item) {
      this.$router.push({name:"ShowClient", params:{id: item.id}})
    },
    getClientPortfolios(){
      if (!this.activeModalityId) return
      this.loading = true
      let params = {...this.local_filter, modality_id: this.activeModalityId}
      Api.ClientPortfolio.index(params).then(r=> {
        this.client_portfolios =  [...r.data.data]
      }).catch(err=>{
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
.index-client-portfolios-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.index-client-portfolios-filters >>> .filter-data-card {
  width: 100%;
}
</style>
